<template>
  <div></div>
</template>
<script>
import { alipay_subscription_for_web } from '../utils/alipay'
export default {
  name: 'alipaySubscription',
  mounted() {
    const { plan } = this.$route.params
    if (this.$route.query.token) {
      if (!this.$store.state.me) {
        const me = {
          access_token: this.$route.query.token,
        }
        this.$store.commit('setMe', me)
      }
      const url = window.location.href
      const newUrl = url.replace(/(\?|&)token=[^&]+/, '')
      window.history.pushState(null, null, newUrl)
      alipay_subscription_for_web(plan)
    } else {
      if (this.$store.state.me) {
        alipay_subscription_for_web(plan)
      } else {
        window.location = '/login'
      }
    }
  },
}
</script>
<style></style>
